module.exports = __webpack_public_path__ + "static/media/green-check.2aef7a8e.svg";